module.exports = __webpack_public_path__ + "static/media/ship.cb4f3b6d.svg";